<template>
  <button-control
    v-if="!isAddedToCart"
    is-block
    :type="typeSecondary"
    :size="size"
    :disabled="isLoading"
    :loading="isLoading"
    @click="handlerAddToBasket"
  >
    В корзину
  </button-control>
  <button-control
    v-else
    is-block
    :type="typeDefault"
    :size="size"
    @click="handlerChangeTab"
  >
    Оформить
  </button-control>
</template>

<script>
import { defineComponent } from '@vue/composition-api';
import { ButtonControl } from '@book24/ui-components';

import { TYPE_ELEMENT_SIZES, TYPES_BUTTON } from '@/utils/constants/globalConst';

import useAddToBasket from '@/compositions/catalog/useAddToBasket';

export default defineComponent({
  name: 'AddToBasketButton',
  components: { ButtonControl },
  props: {
    productId: { type: [String, Number], required: true },
    isLoading: { type: Boolean, default: false },
  },
  setup(props, { emit }) {
    const { isAddedToCart } = useAddToBasket(props.productId);

    const handlerAddToBasket = () => {
      emit('addToBasketItem');
    };

    const handlerChangeTab = () => {
      emit('changeTab');
    };

    return {
      typeSecondary: TYPES_BUTTON.secondary.value,
      typeDefault: TYPES_BUTTON.default.value,
      size: TYPE_ELEMENT_SIZES.small.value,
      isAddedToCart,
      handlerAddToBasket,
      handlerChangeTab,
    };
  },
});
</script>
